// extracted by mini-css-extract-plugin
export default {"card":"card--VI2KeXPH29","icons":"icons--BxuYzRG+LS"};